module.exports = __webpack_public_path__ + "img/Slika7_2021.01a32e98.png";